// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  _germanFormat(number) {
   var postComma, preComma, stringReverse, _ref;
   stringReverse = function(str) {
     return str.split('').reverse().join('');
   };
   _ref = number.toFixed(2).split('.'), preComma = _ref[0], postComma = _ref[1];
   preComma = stringReverse(stringReverse(preComma).match(/.{1,3}/g).join('.'));
   return "" + preComma + "," + postComma;
 }

  _de(){
    return this.inLocaleTarget.value == 'de'
  }
  _set_data(){
    this.recipientTarget.textContent = `${this.inRecipientTarget.value}`
    var message  = this.inMessageTarget.value;
    this.messageTarget.textContent   =  message ;
    this.fromTarget.textContent      = `${this.inFromTarget.value}`
    if (this.hasInValueTarget) {
      var value = this.inValueTarget.value;
      if(value == ""){
        value = "0"
      }
      value = parseInt(value);
      if (this._de())
        { this.valueTarget.textContent     = `€${this._germanFormat(value)}`}
      else
        {  this.valueTarget.textContent     = `€${value}` }
     }
     // UTM hidden fields are populated server-side from the session
     // (see ApplicationController#set_utm). Do not overwrite them here.
  }


  static targets = ["inLocale","inValue", "inRecipient","inFrom", "inMessage", "value","recipient", "message", "from", "utmSource", "utmCampaign", "utmMedium" ]
  initialize() {
     this._set_data();
  }




  update(event){
    this._set_data();
      // $.ajax({
      //      url     :"/gift_cards/preview.json" ,
      //      type    : $( "#new_gift_card" ).attr('method'),
      //      dataType: 'json',
      //      data    : $( "#new_gift_card" ).serialize(),
      //      success : function( data ) {
      //         document.getElementById("preview").contentWindow.document.body.innerHTML=data["html_content"];
      //      }
      //  });

    }
  connect() {
    //this.outputTarget.textContent = 'Hello, Stimulus!'
  }

}
